(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tagg"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const slider = document.getElementById("custom-product-slider");
    if (slider && typeof Flickity !== "undefined") {
      new Flickity(slider, {
        cellAlign: "left",
        contain: true,
        pageDots: true,
        wrapAround: true
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
